<template>
  <div style="padding: 5px;">
    <TableDocumentConfig />
  </div>
</template>
<script>
import TableDocumentConfig from "./components/tableDocumentConfig";

export default {
  components: {
    TableDocumentConfig,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
/* .ant-drawer.ant-drawer-open .ant-drawer-mask {
  opacity: 0;
} */
</style>
